import React, { Component, Fragment } from 'react'
import { ApolloConsumer } from 'react-apollo'

import helpers from '../../helpers'

import { Container, Header, FormContainer, ButtonContainer, Feedback, Content } from './styles'
import { white, red, almostblack, lightgray } from '../../styles/colors'

import Password from '../../components/Input/Password'
import Button from '../../components/Button/'
import PasswordIndicator from '../../components/PasswordIndicator/'

class PasswordForm extends Component {
  constructor(props) {
    super(props)
    this.state = {
      username: '',
      password: '',
      secondPassword: '',
      stayLoggedIn: '',
      usernameValid: '',
      passwordStrength: {
        minimal: '',
        strength: 0
      }
    }
  }

  componentDidMount() {
    this.timer = null
  }

  handleChange(e) {
    if (e.target.name === 'password') {
      this.setState({
        password: e.target.value,
        passwordStrength: helpers.calculatePasswordStrenght(e.target.value)
      })
    } else {
      this.setState({ secondPassword: e.target.value })
    }
  }

  handleSubmit(e) {
    e.preventDefault()
    if (this.state.passwordStrength.minimal && (this.state.password === this.state.secondPassword)) {
      this.props.resetPassword({
        variables: {
          data: {
            token: this.props.match.params.token,
            password: this.state.password
          }
        }
      })
    }
  }

  render() {
    return (
      <ApolloConsumer>
        {client => {
          this.client = client
          return (
            <Container>
              <Header>Wachtwoord opnieuw instellen</Header>
              {this.props.data ? (
                <Content>Uw wachtwoord is opnieuw ingesteld. U kunt nu <a href="/login">inloggen</a>.</Content>
              ) : (
                <FormContainer onSubmit={this.handleSubmit.bind(this)}>
                <Password
                  value={this.state.password}
                  handleChange={this.handleChange.bind(this)}
                  type="password"
                  name="password"
                  placeholder="Wachtwoord"
                  icon="lock"
                  valid={this.state.passwordStrength.minimal}
                />
                {this.state.passwordStrength.minimal ? (
                  <Password
                    value={this.state.secondPassword}
                    handleChange={this.handleChange.bind(this)}
                    type="password"
                    name="second_password"
                    placeholder="Wachtwoord bevestigen"
                    icon="lock"
                    valid={this.state.password === this.state.secondPassword}
                  />
                ) : null}
                {this.state.passwordStrength.minimal ? (
                  <Fragment>
                    {this.state.secondPassword !== '' && (this.state.password !== this.state.secondPassword) ? (
                      <Feedback>Wachtwoorden komen niet overeen</Feedback>
                    ) : <PasswordIndicator passwordStrength={this.state.passwordStrength} />}
                  </Fragment>
                ) : this.state.passwordStrength.minimal === false ? (
                  <Feedback>Nog minimaal {10 - this.state.password.length} tekens toevoegen.</Feedback>
                ) : null}
                {this.props.loading ? <Feedback>Laden..</Feedback> : null}
                {this.props.error ? <Feedback>{this.props.error.message.replace('GraphQL error:', '')}</Feedback> : null}
                <ButtonContainer>
                  <Button
                    background={this.state.passwordStrength.minimal && this.state.password === this.state.secondPassword ? red : lightgray}
                    color={white}
                    radius="true"
                    hover={this.state.passwordStrength.minimal && this.state.password === this.state.secondPassword ? almostblack : lightgray}
                    onSubmit={this.handleSubmit.bind(this)}
                  >
                    Verzenden
                  </Button>
                </ButtonContainer>
              </FormContainer>
              )}
            </Container>
          )
        }}
      </ApolloConsumer>
    )
  }
}

export default PasswordForm



// WEBPACK FOOTER //
// ./src/containers/PasswordForm/index.js